import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcParking(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.5A6.5 6.5 0 0 0 5.5 10c0 2.018.9 4.123 2.113 6.026 1.205 1.891 2.668 3.506 3.682 4.526a.98.98 0 0 0 1.416.003c1.015-1.013 2.476-2.618 3.679-4.506C17.6 14.15 18.5 12.04 18.5 10A6.5 6.5 0 0 0 12 3.5M4 10a8 8 0 1 1 16 0c0 2.453-1.069 4.852-2.345 6.855-1.284 2.015-2.827 3.706-3.884 4.761a2.48 2.48 0 0 1-3.54-.006c-1.055-1.061-2.599-2.762-3.883-4.778C5.07 14.828 4 12.433 4 10",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.194 11.66v1.821a.535.535 0 0 1-1.07 0v-5.86a.5.5 0 0 1 .5-.5h2.085c1.337 0 2.269.923 2.269 2.265 0 1.348-.95 2.275-2.303 2.275zm0-.898h1.228c.932 0 1.462-.501 1.462-1.37s-.53-1.367-1.457-1.367h-1.233z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.05 7.549a.5.5 0 0 1 .5-.5h2.159c.686 0 1.272.237 1.687.65s.655.999.655 1.687c0 .692-.245 1.28-.666 1.695s-1.017.652-1.71.652h-1.408v1.748a.608.608 0 0 1-1.216 0zm.646-.355a.5.5 0 0 0-.5.5v5.787a.462.462 0 0 0 .925 0v-1.893h1.554c.66 0 1.216-.226 1.608-.611.391-.385.622-.935.622-1.59s-.226-1.202-.611-1.585c-.386-.383-.934-.608-1.585-.608zm.425.758h1.306c.476 0 .86.127 1.126.377s.404.612.404 1.062-.138.814-.405 1.065c-.266.25-.652.38-1.13.38h-1.3zm.146.145v2.593h1.155c.453 0 .799-.122 1.03-.34.232-.217.36-.54.36-.959 0-.42-.128-.74-.359-.956-.23-.217-.575-.338-1.026-.338z",
    clipRule: "evenodd"
  }));
}
var IcParking = createNolIcon(/*#__PURE__*/forwardRef(SvgIcParking));

export { IcParking as I };
